<template>
  <div class="main_box">
    <el-form :inline="true" style="width: 100%">
      <el-form-item label="模板名称">
        <el-input v-model="areaLimitName" placeholder="请输入模板名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <div class="col">
          <el-button @click="allSelArea" size="small" type="primary">全选</el-button>
          <el-button @click="onReset" size="small" type="danger">清除</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="tree_box" v-loading="loading">
      <el-tree
        ref="tree"
        :data="areaList"
        node-key="id"
        :props="treeProps"
        show-checkbox
        :default-expanded-keys="idArr"
        :default-checked-keys="idArr"
        :accordion="true"
        :highlight-current="true"
        :check-on-click-node="true"
        @check="handleCheckChange"
      ></el-tree>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" v-preventClick @click.native="submitFun">提交</el-button>
    </div>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  areaTreeList2,
  addAreaLimit,
  updateAreaLimit,
  areaIdList,
} from "../../../api/api";
export default {
  props: ["editForm","supId"],
  data() {
    return {
      param: {},
      areaLimitName: "",
      loading: true,
      areaList: [],
      treeProps: {
        label: "areaName",
        children: "childrens",
      },
      idArr: [],
    };
  },
  created() {
    this.param = `areaLimitId=${this.editForm.id ? this.editForm.id : null}`
    this.areaLimitName = this.editForm.id ? this.editForm.areaLimitName : null;
    this.getAreaTreeList(this.param);
  },
  methods: {
    getAreaTreeList(param) {
      let that = this;
      let data = {
        path: 'System_Area/TreeList3',
      }
      KSAXApiRequest(data).then((res) => {
        that.areaList = res.data.response;
        that.loading = false;
        if (that.editForm.id) {
          let obj = {
            path: 'Product_AreaLimitDetail/AreaIdList',
            parms: param,
          }
          KSAXApiRequest(obj).then((res) => {
            that.idArr = res.data.response;
          });
        }
      });
    },
    allSelArea() {
      let that = this;
      that.idArr = [];
      that.areaList.forEach((v, i) => {
        v.childrens.forEach((v1) => {
          that.idArr.push(v1.id);
        });
      });
      that.$refs.tree.setCheckedNodes(that.idArr);
    },
    handleCheckChange(e) {
      let that = this;
      that.idArr = that.$refs.tree.getCheckedKeys(true);
    },
    onReset() {
      this.idArr.length = 0;
      this.getAreaTreeList();
    },
    submitFun() {
      let that = this;
      if (that.areaLimitName == "" || that.areaLimitName == null)
        return that.$message.error("请输入模板名称");
      if (!that.idArr) return that.$message.error("请勾选地区");
      if (that.editForm.id) {
        let params = {
          path: 'Product_AreaLimit/Update',
          parms: '',
          parmsJson: {
            supId: that.supId,
            id: that.editForm.id,
            areaLimitName: that.areaLimitName,
            enabled: true,
            areaIds: that.idArr,
          }
        };
        KSAXApiRequest(params).then((res) => {
          that.$message.success(res.data.msg);
          that.$emit("getSpecs");
        });
      } else {
        let params = {
          path: 'Product_AreaLimit/Add',
          parms: '',
          parmsJson: {
            supId: that.supId,
            areaLimitName: that.areaLimitName,
            enabled: true,
            areaIds: that.idArr,
          }
        };
        KSAXApiRequest(params).then((res) => {
          that.$message.success(res.data.msg);
          that.$emit("getSpecs");
        });
      }
    },
  },
};
</script>
<style scoped>
.dialog-footer {
  padding: 20px;
  text-align: center;
}
</style>